module.exports = __webpack_public_path__ + "assets/images/b9b13c9ab99f8fa3c958f8a7b0773c98.png";